import { put, select, takeLatest } from "redux-saga/effects"
import { loginWatcher, mfaSetEmail } from "../actions/loginactioncreators"
import actiontypes from "../actions/actiontypes";
import getUserAttributes from "../helpers/getUserAttributes";
import getChallenge from "../helpers/getChallenge";
import flowStages from "../../flowStages";
import getPassword from "../helpers/getPassword";


export function* initiateEmailMfa(action) {
    if (action.payload.flowStage === "MFA_SETUP_EMAIL") {
        const userAttributes = yield select(getUserAttributes);
        const email = userAttributes?.email;
        const challenge = yield select(getChallenge);
        const password = yield select(getPassword);

        const emailMfaPayload = {
            flowStage: flowStages.CHALLENGE_MFA_SETUP,
            challengeResponse: {
                session: challenge.session,
                challengeName: challenge.challengeName,
                step: "MFA_SETUP_EMAIL",
                challengeParameters: {
                    USERNAME: challenge.challengeParameters.USER_ID_FOR_SRP,
                    MFA_CONFIG: {
                        EMAIL: email
                    },
                    PASSWORD: password,
                    MFA_OPTIONS: challenge.challengeParameters["MFA_OPTIONS"] ?? undefined
                }
            }
        };

        yield put(mfaSetEmail(email));
        yield put(loginWatcher(emailMfaPayload));
    }
}

export function* watchMfaEmailInit() {
    yield takeLatest(actiontypes.USER_LOGIN_FLOW_STAGE, initiateEmailMfa);
}
